<template>
    <div class='download-navigation-wrapper O(∩_∩)O'>
        <div class="download-navigation align-c">
            <!-- 左边 -->
            <div class="download-navigation-l">
                <div class="center-wrapper">
                    <h1>森果收银台</h1>
                    <p>三分钟快速上手</p>
                    <p>高效收银，提升经营效率</p>
                    <div class="btn-wrapper">
                        <button class="btn download-android"
                            @click="toDownload('windows')">
                            <i class="iconfont iconwindows fs-24"/>
                            <div>
                                <p>windows</p>
                                <p>下载</p>
                            </div>
                        </button>
                        <button class="btn download-android"
                            @click="toDownload('android')">
                            <i class="iconfont iconandroid fs-28"/>
                            <div>
                                <p>Android</p>
                                <p>下载</p>
                            </div>
                        </button>
                    </div>
                </div>
                <div class="img-wrapper">
                    <img class="big-img" :src="icons.cashierIcon" alt="">
                    <img v-for="(value, key) in cashierIcons"
                        class="img-icon"
                        :key="key"
                        :src="value"
                        :alt="key"
                        :class="key"
                        :ref="key">
                </div>
            </div>
            <!-- 右边 -->
            <div class="download-navigation-r">
                <div class="center-wrapper">
                    <h1>森果零售通</h1>
                    <p>手机上的零售后台</p>
                    <p>随时随地管理店铺</p>
                    <div class="btn-wrapper">
                        <el-popover placement="top"
                            popper-class="__download-navigation-popper__">
                            <button class="btn download-shanghutong"
                                slot="reference">
                                <i class="iconfont iconerweima fs-24"/>
                                <div>
                                    <p class="fs-18">手机扫码</p>
                                    <p>下载</p>
                                </div>
                            </button>
                            <div class="img">
                                <img :src="shanghutongSrc" alt="">
                            </div>
                        </el-popover>
                    </div>
                </div>
                <div class="img-wrapper">
                    <img class="big-img" :src="icons.mobileBackstageIcon" alt="">
                    <img v-for="(value, key) in mobileBackstageIcons"
                        class="img-icon"
                        :key="key"
                        :src="value"
                        :alt="key"
                        :class="key"
                        :ref="key">
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { createComponent, ref, computed, onBeforeUnmount, onBeforeMount, onMounted } from '@vue/composition-api'
import { openMessage } from '../../utils/system'
import domain from '@/config/domain'
import Qrcode from 'qrcode'

// icons
// @ts-ignore
import cashierIcon from './images/syt.png'
// @ts-ignore
import mobileBackstageIcon from './images/lst.png'
// @ts-ignore
import ddjm from './images/ddjm.svg'
// @ts-ignore
import sd from './images/sd.svg'
// @ts-ignore
import hywf from './images/hywf.svg'
// @ts-ignore
import money from './images/money.svg'
// @ts-ignore
import lsgj from './images/lsgj.svg'
// @ts-ignore
import ssqz from './images/ssqz.svg'
// @ts-ignore
import vip from './images/vip.svg'
// @ts-ignore
import jjb from './images/jjb.svg'
// @ts-ignore
import jssy from './images/jssy.png'
// @ts-ignore
import ckdd from './images/ckdd.svg'
// @ts-ignore
import tjhpicon from './images/tjhpicon.svg'
// @ts-ignore
import dpsj from './images/dpsj.svg'
// @ts-ignore
import ckddicon from './images/ckddicon.svg'
// @ts-ignore
import dpsjicon from './images/dpsjicon.svg'
// @ts-ignore
import tjhp from './images/tjhp.svg'
import $fetch from '../../api'

export default createComponent({
    setup(props, ctx) {
        const shanghutongSrc = ref('')
        const urls = ref<{
            retail_app_url: string,
            cashier_app_url: string,
            windows_cashier_app_url: string
        }>({
            retail_app_url: '',
            cashier_app_url: '',
            windows_cashier_app_url: ""
        })

        const icons = computed(() => {
            return {
                cashierIcon,
                mobileBackstageIcon
            }
        })

        const cashierIcons = computed(() => {
            return {
                ddjm,
                sd,
                hywf,
                money,
                lsgj,
                ssqz,
                vip,
                jjb,
                jssy
            }
        })

        const mobileBackstageIcons = computed(() => {
            return {
                ckdd,
                tjhpicon,
                dpsj,
                ckddicon,
                dpsjicon,
                tjhp
            }
        })

        onBeforeMount(() => {
            getShanghutongSrc()
        })

        onMounted(() => {
            // getRetailAppupdateUrl()
            getCashierAppUpdateUrl()
            getWindowsCashierDownloadUrl()
            iconRunDelay()
        })

        // async function getRetailAppupdateUrl() {
        //     try {
        //         const result = await $fetch.post({
        //             url: '/common/retailappupdateurl'
        //         })
        //         console.log('商户通下载链接', result)
        //         urls.value.retail_app_url = result.retail_app_url
        //     } catch (e) {
        //         openMessage('error', e.message || '获取商户通下载链接失败')
        //     }
        // }

        async function getCashierAppUpdateUrl() {
            try {
                const result = await $fetch.post({
                    url: '/common/cashierappversiondetail'
                })
                console.log('收银台下载链接', result)
                urls.value.cashier_app_url = result.app_url
            } catch (e) {
                openMessage('error', e.message || '获取收银台下载链接失败')
            }
        }

        function getWindowsCashierDownloadUrl() {
            $fetch.post({
                url: '/common/cashierappversiondetail',
                params: {
                    type: 2
                }
            }).then(data => {
                urls.value.windows_cashier_app_url = data.app_url
            }).catch(e => {
                openMessage('error', e.message || '获取windows收银台下载链接失败')
            })
        }

        function iconRunDelay() {
            Object.keys(ctx.refs).forEach(k => {
                if (ctx.refs[k][0] instanceof Image) {
                    ctx.refs[k][0].style.animationDelay = Math.random() * 4 + 's'
                }
            })
        }

        function getShanghutongSrc() {
            Qrcode.toDataURL(`${domain.cashierMobile}#/download`, (err, url) => {
                if (err) {
                    return openMessage('error', '生成商户通二维码失败')
                }
                shanghutongSrc.value = url
            })
        }

        function toDownload(type) {
            switch (type) {
                case 'android':
                    window.location.href = urls.value.cashier_app_url
                    break
                case 'windows':
                    window.location.href = urls.value.windows_cashier_app_url
                    break
                default:
                    break
            }
        }

        return {
            urls,
            shanghutongSrc,
            icons,
            cashierIcons,
            mobileBackstageIcons,
            toDownload
        }
    }
})
</script>

<style lang="scss">
.__download-navigation-popper__ {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 120px !important;
    width: 120px;
    height: 120px;
    padding: 10px;
    transform: translateY(8px);
    box-sizing: border-box;

    > .img {
        width: 100px;
        height: 100px;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            transform: scale(1.3);
        }
    }
}
</style>

<style lang="scss" scoped>
.download-navigation-wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;
}

.download-navigation {
    display: flex;
    width: 100%;
    height: 100%;
    background: #f7f7f7;
    overflow: auto;
    color: #333;

    > div {
        position: relative;
        flex: 1 0 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;

        > .center-wrapper {
            position: absolute;
            top: 15%;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            z-index: 1;

            > h1 {
                font-size: 40px;
                font-weight: 600;
                line-height: 56px;
            }

            > p {
                font-size: 14px;
                line-height: 20px;
            }

            > .btn-wrapper {
                width: 100%;
                margin-top: 40px;
                text-align: center;

                .btn {
                    display: inline-flex;
                    align-items: center;
                    height: 60px;
                    margin-right: 40px;
                    padding: 0 30px;
                    background-color: #fff;
                    box-shadow: 0 4px 20px -4px rgba(0, 0, 0, .1);
                    border-radius: 30px;
                    text-align: center;
                    outline: none;
                    cursor: pointer;

                    &:hover {
                        transform: scale(1.05);
                        color: #707070;
                    }

                    &:active {
                        background-color: rgba(0, 0, 0, .1);
                    }

                    div {
                        line-height: 20px;
                        margin-left: 10px;
                        font-size: 20px;
                        font-weight: 600;
                        text-align: left;

                        p:nth-child(2) {
                            font-size: 16px;
                            margin-top: 2px;
                        }
                    }

                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
        }

        > .img-wrapper {
            position: relative;
            display: flex;
            align-items: flex-end;
            width: 100%;
            text-align: center;

            > .big-img {
                width: 100%;
            }

            @keyframes iconRun {
                0% {
                    transform: translateY(10px);
                }
                100% {
                    transform: translateY(-10px);
                }
            }

            > .img-icon {
                position: absolute;
                animation: iconRun 4s ease-out 0s infinite alternate both;

                &.ddjm {
                    left: 3%;
                    bottom: 12%;
                }

                &.sd {
                    left: 12%;
                    bottom: 41%;
                }

                &.hywf {
                    left: 20%;
                    bottom: 58%;
                }

                &.lsgj {
                    left: 33%;
                    bottom: 46%;
                }

                &.money {
                    left: 38%;
                    bottom: 64%;
                }

                &.ssqz {
                    left: 57%;
                    bottom: 60%;
                }

                &.vip {
                    left: 62%;
                    bottom: 46%;
                }

                &.jjb {
                    left: 70%;
                    bottom: 28%;
                }

                &.jssy {
                    left: 71%;
                    bottom: 2%;
                }

                &.ckdd {
                    left: 8%;
                    bottom: 28%;
                }

                &.tjhpicon {
                    left: 24%;
                    bottom: 56%;
                }

                &.dpsj {
                    left: 40%;
                    bottom: 56%;
                }

                &.ckddicon {
                    left: 54%;
                    bottom: 68%;
                }

                &.dpsjicon {
                    left: 69%;
                    bottom: 50%;
                }

                &.tjhp {
                    left: 78%;
                    bottom: 10%;
                }
            }
        }
    }

    // &-r {
    //     div.btn-wrapper {
    //         .btn {
    //             padding: 0 30px !important;

    //             > div {
    //                 font-size: 20px;
    //                 line-height: 28px;
    //             }
    //         }
    //     }
    // }
}
</style>
